import { color } from './color';

export const background = {
	default: color.background.default,
	light: color.background.light,
	highlight: color.highlight,
};
